var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "audio-manage" }, _vm._l(_vm.resources, function (tag) {
    return _c('div', { key: tag.tag_id, staticClass: "audio-tag-list-item" }, [_c('div', { staticClass: "list-hd" }, [_c('span', [_vm._v("\n        " + _vm._s(tag.name) + "\n      ")]), _vm._v(" "), _c('a', { on: { "click": function click($event) {
          $event.preventDefault();return _vm.getTargetTypeComponents(tag);
        } } }, [_vm._v("\n        " + _vm._s(_vm.$t('workbench.resourceManagers.all')) + "\n        "), _c('svg-icon', { attrs: { "icon-class": "arrow_right" } })], 1)]), _vm._v(" "), _vm._l(tag.assets, function (resource) {
      return _c('audio-item', { key: resource.id, ref: "audioItemRef", refInFor: true, attrs: { "resource": resource }, on: { "play": _vm.handlePlay, "addResource": _vm.handleAddResource } });
    })], 2);
  }), 0);
};
var staticRenderFns = [];

export { render, staticRenderFns };